<template>
    <button class="button-default" :class="{'extra-small': extraSmall, 'small': small,
      'medium': medium, 'outline': outline, 'clen': clen, 'full': full}" :disabled="disabled">
      {{description}}
    </button>
</template>

<script>
export default {
  name: 'btn',
  props: {
    description: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    extraSmall: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    clen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  mounted() {

  },
  methods: {

  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .button-default
    height: 34px
    display: flex
    align-items: center
    justify-content: center
    color: $grey-800
    font-weight: 600
    cursor: pointer
    // background-color: $primary
    font-style: italic
    border: 1px solid $brand-twoo
    text-transform: lowercase
    font-size: 14px
    &:hover
      border-color: $brand-twoo
      background-color: $brand-one
    &.extra-small
      width: 40px
    &.clen
      height: 24px
    &.small
      width: 126px
    &.medium
      width: 155px
    &.full
      width: 100%
    &.outline
      background-color: transparent
      &:hover
        // background-color: $secundary
      &:disabled
        &:hover
          background-color: transparent !important
    &.extra-small, &.small, &.medium, &.outline
      &:disabled
        opacity: .6
        cursor: not-allowed
        &:hover
          // background-color: $primary
</style>
